"use client";

import st from "./index.module.scss";
import { useTranslations } from "next-intl";
import React from "react";
import Image from "next/image";

export default function CashbackBonusModal() {
  const t = useTranslations("CashbackBonusModal");

  return (
    <div className={st.wrapper}>
      <div className={st.header}>
        <div className={st.header_title}>
          <span className={st.header_title__orange}>+15%</span> {t("header")}
        </div>
        <div className={st.header_image}>
          <Image
            src="/images/bonuses/cashback.webp"
            alt="Bazz Bet Cashback"
            width={351}
            height={234}
            loading="lazy"
            sizes="(max-width: 768px) 100vw, 800px"
            style={{ width: "100%", height: "auto" }}
          />
        </div>
      </div>
      <div className={st.description}>
        <div className={st.description_title}>{t("title")}</div>
        <div className={st.description_subtitle}>{t("conditions")}</div>
        <div className={`${st.description_subtitle} ${st.description_subtitle_dot}`}>
          {t("auto")}
        </div>
        <div className={`${st.description_subtitle} ${st.description_subtitle_dot}`}>
          {t("deposits")}
        </div>
        <div className={`${st.description_subtitle} ${st.description_subtitle_dot}`}>
          {t("percentTitle")}
          <br />
          <br />• {t("percentTiers.tier1")}
          <br />• {t("percentTiers.tier2")}
          <br />• {t("percentTiers.tier3")}
          <br />• {t("percentTiers.tier4")}
          <br />• {t("percentTiers.tier5")}
        </div>
        <br />
        <div className={st.description_subtitle}>{t("rulesTitle")}</div>
        <div className={`${st.description_subtitle} ${st.description_subtitle_dot}`}>
          {t("rules.allCurrencies")}
        </div>
        <div className={`${st.description_subtitle} ${st.description_subtitle_dot}`}>
          {t("rules.activeCurrency")}
        </div>
        <div className={`${st.description_subtitle} ${st.description_subtitle_dot}`}>
          {t("rules.once")}
        </div>
        <div className={`${st.description_subtitle} ${st.description_subtitle_dot}`}>
          {t("rules.noDuplicates")}
        </div>
      </div>
    </div>
  );
}
